import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import WelcomeImage from "../../components/WelcomeImage";
import ImageText1 from "../../components/ImageText1";
import Footer from "../../components/Footer";
import backgroundImage from "../../assets/images/wiezijnwij/bg-wizijnwij.jpg";
import imageUrl1 from "../../assets/images/wiezijnwij/a.jpg";
import imageUrl2 from "../../assets/images/wiezijnwij/b.jpg";
import imageUrl3 from "../../assets/images/wiezijnwij/c.jpg";
import imageUrl4 from "../../assets/images/wiezijnwij/d.png";
import ImageText2 from "../../components/ImageText2";
function WieZijnWij() {
  const welcomeHeading = "Wie Zijn Wij";

  const imageTextText = (
    <>
      Ik ben een recruiter en detacheerder in hart en nieren, daarnaast beschik
      ik over ruime expertise in sales en finance. Vanuit mijn kennis en
      ervaring adviseer ik op dat vlak organisaties en zelfstandigen. <br />
      Ik ben circa 28 jaar werkzaam als accountmanager en salesmanager en ben
      ooit begonnen als crisismanager. <br />
      In 2017 heb ik besloten om zelfstandig een bedrijf op te richten,
      allereerst als eenmanszaak en na 2,5 jaar als B.V. met een partner. Ik
      beschik over een groot netwerk in de technische branche, infra en
      industrie verbonden aan vele grote bedrijven. Ik ben in staat om snel met
      behoud van kwaliteit de juiste kandidaat te vinden. <br />
      Ik word gebeld door een prospect wanneer een andere partij niet kan
      leveren en door een bestaande klant wanneer deze urgent of voor langere
      termijn invulling nodig heeft van hooggekwalificeerd personeel. <br />
      Ik kom graag met u in contact! <br />
      E-mail:{" "}
      <strong>
        <a href="mailto:m.boer@dd-group.nl">m.boer@dd-group.nl</a>
      </strong>{" "}
      <br />
      Tel:{" "}
      <strong>
        <a href="tel:0031653407081">0031-653407081</a>
      </strong>
    </>
  );

  const imageTextText2 = (
    <>
      Ik heb meer dan 25 jaar ervaring als inkoop- en logistiek manager in de
      internationale scheepvaart en alle facetten van het wereldwijde logistieke
      proces. Na een korte uitstap als procurement lead in de olie- en
      gasindustrie ben ik per 1 januari 2023 mijn eigen bedrijf begonnen als
      recruiter en interim procurement consultant. <br />
      Door mijn zeer uitgebreide netwerk in zowel de maritieme als de olie- en
      gasindustrie laveer ik feilloos tussen kandidaat en opdrachtgever. Ik maak
      hierbij gebruik van diverse tools en uiteraard mijn bestaande netwerk.{" "}
      <br />
      Wilt u gebruik maken van deze diensten, dan kom ik graag met u in contact!{" "}
      <br />
      E-mail:{" "}
      <strong>
        <a href="mailto:t.ligthart@dd-group.nl">t.ligthart@dd-group.nl</a>
      </strong>{" "}
      <br />
      Tel:{" "}
      <strong>
        <a href="tel:0031-625308642">0031-625308642</a>
      </strong>
    </>
  );
  const imageTextText3 = (
    <>
      Na mijn opleiding Bedrijfssociologie/-kunde aan de Erasmus Universiteit te
      Rotterdam in 1990 begon ik mijn loopbaan in HR en Organisatieadvies.{" "}
      <br />
      Mijn ervaring op het gebied van verandermanagement en Human Resources is
      breed: organisatie- en leiderschapsontwikkeling, generalist op het gebied
      van HR, overleg en onderhandelen met OR, Vakbonden en medezeggenschap,
      herinrichten en digitaliseren van processen, opzetten of herinrichten
      HR-afdeling of HR-functie. Ik werk op strategisch, tactisch en
      operationeel niveau, als leidinggevende of als adviseur. Ik ben een
      sparringpartner van ondernemers, bestuurders, directeuren en
      leidinggevenden, zowel in een nationale als in een internationale context
      in organisaties variërend van groot tot klein. <br />
      De branches waarbinnen ik werk dan wel heb gewerkt zijn
      Energie-/Nutssector, Kabel, Media, ICT, Bank- en Verzekeringswezen, MKB,
      Zorg, Onderwijs, Bouw, Infra, Industrie en Maritiem. <br />
      Mijn werkaanpak kenmerkt zich door een verbindende, professionele,
      transparante, pragmatische en resultaatgerichte werkwijze. <br />
      Ik kom graag met u in contact! <br />
      E-mail:{" "}
      <strong>
        <a href="mailto:d.degraaff@dd-group.nl">d.degraaff@dd-group.nl</a>
      </strong>{" "}
      <br />
      Tel.:{" "}
      <strong>
        <a href="tel:0031-655180540">0031-655180540</a>
      </strong>
    </>
  );
  const imageTextText4 = (
    <>
      Ik ben mijn loopbaan gestart in de interieurbouw met een rode draad in het
      facilitaire werkveld. Een groot deel van mijn carrière heb ik ook de rol
      van projectmanager in de ict bank- en verzekeringswezen vervuld, alsmede
      facilitair manager in inkoop-en contractmanagement o.a. bij de overheid.{" "}
      <br />
      Door mijn ervaringen ben ik meer en meer geïnteresseerd geraakt in
      persoonlijke ontwikkeling en ben me daarom gaan omscholen tot holistisch
      lifestyle coach en me naar de meer menselijke kant van verandermanagement
      gaan richten. Mijn kracht is, dat ik me goed kan inleven in andere mensen,
      situaties, het geheel kan blijven overzien en weet hoe te handelen. Ik kan
      goed plannen & organiseren en kan door mijn sensitiviteit gemakkelijk
      verbinden en kan goed ‘vooruitzien’. Ik ben dan ook inzetbaar als coach,
      loopbaanadviseur en projectmanager op het gebied van events, huisvesting
      en facilitaire projecten. <br />
      Mijn doortastende aanpak kenmerkt zich door mijn open, eerlijke,
      transparante werkhouding wat professioneel, verbindend en heel pragmatisch
      werkt. <br />
      Ik zorg ervoor dat we de juiste mensen op de juiste plaats kunnen brengen,
      middels o.a. loopbaan coaching en werving & selectie voor de Nederlandse
      en Belgische arbeidsmarkt. <br />
      Wil je ook op de juiste plek voor jou terecht komen in ons netwerk? <br />
      Ik kom graag met u in contact!   <br />
      E-mail:{" "}
      <strong>
        <a href="mailto:c.vaneijbergen@dd-group.nl">
          c.vaneijbergen@dd-group.nl
        </a>
      </strong>{" "}
      <br />
      Tel:{" "}
      <strong>
        <a href="tel:0031-628885846">0031-628885846</a>
      </strong>
    </>
  );

  // const backgroundColor = "#D9D9D9";
  // const textColor = "black";

  return (
    <div>
      <Helmet>
        <title>Wie Zijn Wij</title>
        <meta
          name="description"
          content="Krijg training met DD-Group over veiligheid, brandpreventie en cybersecurity via Play-IT. Voor interne transport- en veiligheidstrainingen kun je contact met ons opnemen, en wij verbinden je met 'The Knowledge' voor het beste aanbod via onze speciale referentie."
        />
      </Helmet>
      <header>
        <Header />
      </header>
      <main>
        <WelcomeImage
          backgroundImage={backgroundImage}
          heading={welcomeHeading}
        />
        <section>
          <ImageText2
            imageUrl={imageUrl1}
            heading="Marcel Boer"
            text={imageTextText}
            // backgroundColor="#D9D9D9"
            // textColor="black"
          />

          <ImageText1
            imageUrl={imageUrl2}
            heading="Tjeerd Ligthart"
            text={imageTextText2}
            backgroundColor="#D9D9D9"
            textColor="black"
          />
          <ImageText2
            imageUrl={imageUrl3}
            heading="Desirée de Graaff-Axt"
            text={imageTextText3}
            // backgroundColor="#D9D9D9"
            // textColor="black"
          />

          {/* <ImageText1
            imageUrl={imageUrl4}
            heading="Connie van Eijbergen"
            text={imageTextText4}
            backgroundColor="#D9D9D9"
            textColor="black"
          /> */}
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default WieZijnWij;
